<template>
  <custom-dialog width="80%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="firstpay-dialog-body">
      <contract-payment ref="payment" backType="changeFirstpay" :contractId="contractId" :contractClass="contractClass" :operateFlag="operateFlag" @success="onSuccess"></contract-payment>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import contractPayment from '../contractComponents/contract_payment.vue';

export default {
  mixins: [dialogMixins],
  components: { contractPayment },
  provide() {
    return {
      getContractInfo: () => this.contractInfo,
    };
  },
  data() {
    return {
      contractId: '',
      contractClass: '',
      operateFlag: '',
      contractInfo: {},
    };
  },
  mounted() {
    this.contractId = this.model.data.bizId;
    this.contractClass = this.model.data.bizClass;
    this.getContractDetail();
  },
  methods: {
    // 合同详情
    getContractDetail: function () {
      this.$getJSON(apis.contractInfo, {
        bizId: this.contractId,
        bizClass: this.contractClass,
      }).then((res) => {
        this.contractInfo = res.data;
      });
    },
    // 提交
    confirm: function () {
      if (this.$refs.payment) {
        this.$refs.payment.savePayment();
      }
    },
    // 成功
    onSuccess: function () {
      this.$emit('success');
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.firstpay-dialog-body {
  padding: 10px 0 24px;
}
</style>
